/**
 * Famous personalities by Vedic ascendant (Lagna) sign.
 * Images live at: /public/Assets/reports/famous-personalities/{sign}-{1|2|3}.jpg
 * Each image should be 200×200 px, JPG format, subject centred.
 *
 * UPDATE the names below to match whoever you choose for each sign.
 */

export interface FamousPersonality {
  name: string;
  /** Optional note, e.g. profession or known for */
  note?: string;
}

/** Record of 3 personalities per Vedic ascendant sign (lowercase key). */
export const FAMOUS_BY_ASCENDANT: Record<string, [FamousPersonality, FamousPersonality, FamousPersonality]> = {
  aries: [
    { name: 'Priyanka Chopra', note: 'Actress' },
    { name: 'AR Rehman', note: 'Music Composer' },
    { name: 'Sourav Ganguly', note: 'Cricketer' },
  ],
  taurus: [
    { name: 'Lata Mangeshkar', note: 'Singer' },
    { name: 'Kamal Haasan', note: 'Actor' },
    { name: 'Aishwarya Rai', note: 'Actress' },
  ],
  gemini: [
    { name: 'Bill Gates', note: 'Entrepreneur' },
    { name: 'Karan Johar', note: 'Filmmaker' },
    { name: 'Sonam Kapoor', note: 'Actress' },
  ],
  cancer: [
    { name: 'Rohit Sharma', note: 'Cricketer' },
    { name: 'APJ Abdul Kalam', note: 'Former President' },
    { name: 'Sachin Tendulkar', note: 'Cricketer' },
  ],
  leo: [
    { name: 'Shah Rukh Khan', note: 'Actor' },
    { name: 'Rajinikanth', note: 'Actor' },
    { name: 'Sridevi', note: 'Actress' },
  ],
  virgo: [
    { name: 'Rishi Kapoor', note: 'Actor' },
    { name: 'Mahendra Singh Dhoni', note: 'Cricketer' },
    { name: 'Ranveer Singh', note: 'Actor' },
  ],
  libra: [
    { name: 'Kareena Kapoor', note: 'Actress' },
    { name: 'Hardik Pandya', note: 'Cricketer' },
    { name: 'Nirmala Sitharaman', note: 'Politician' },
  ],
  scorpio: [
    { name: 'Narendra Modi', note: 'Politician' },
    { name: 'Hrithik Roshan', note: 'Actor' },
    { name: 'Mukesh Ambani', note: 'Businessman' },
  ],
  sagittarius: [
    { name: 'Virat Kohli', note: 'Cricketer' },
    { name: 'Ratan Tata', note: 'Businessman' },
    { name: 'Rekha', note: 'Actress' },
  ],
  capricorn: [
    { name: 'Deepika Padukone', note: 'Actress' },
    { name: 'Dilip Kumar', note: 'Actor' },
    { name: 'Aliya Bhatt', note: 'Actress' },
  ],
  aquarius: [
    { name: 'Salman Khan', note: 'Actor' },
    { name: 'Aamir Khan', note: 'Actor' },
    { name: 'Amitabh Bachchan', note: 'Actor' },
  ],
  pisces: [
    { name: 'Rahul Dravid', note: 'Cricketer' },
    { name: 'Farhan Akhtar', note: 'Actor' },
    { name: 'Vidya Balan', note: 'Actress' },
  ],
};
